(function () {
    if (window.location.pathname !== '/car-rental-franchise/apply') return;

    $('#title').selectize();

    $.get('/static/datasets/countries', function (countries) {
        $('#country, #country-of-interest').selectize({
            valueField: 'code',
            labelField: 'name',
            searchField: 'name',
            sortField: 'name',
            selectOnTab: true,
            options: countries,
        });
    });
})();
